// extracted by mini-css-extract-plugin
module.exports = {"root":"AssetLookLayout_root__3nick","header":"AssetLookLayout_header__2r-Rs","sidebar":"AssetLookLayout_sidebar__dKASA","content":"AssetLookLayout_content__22JIP"};